<script setup lang="ts">
import { nextTick } from "vue";

import type { DropdownGeneratorAction } from "./types";

import { DropdownItem, DropdownSeparator, DropdownTitle } from "../Dropdown";

interface DropdownGeneratorProps {
    actions: DropdownGeneratorAction[];
    // biome-ignore lint/suspicious/noExplicitAny: Init Biome
    relatedData?: any;
}

const props = defineProps<DropdownGeneratorProps>();

const emit = defineEmits<{
    // biome-ignore lint/suspicious/noExplicitAny: Init Biome
    (e: "click", item: any, index: number): void;
    (e: "select"): void;
}>();

// biome-ignore lint/suspicious/noExplicitAny: Init Biome
// biome-ignore lint/complexity/noBannedTypes: Init Biome
const handleDropdownItemClick = (fn: Function, item: any, index: number) => {
    if (fn && typeof fn === "function") {
        nextTick(() => fn(props.relatedData));
    } else {
        emit("click", item, index);
    }
};

// biome-ignore lint/suspicious/noExplicitAny: Init Biome
const getItemPropsWithoutOnClick = (item: any) => {
    const { onClick, ...rest } = item;
    return rest;
};
</script>

<template>
    <div class="dropdown-generator">
        <!-- biome-ignore lint/correctness/useVueVForKey: Init Biome -->
        <template v-for="(action, index) of actions">
            <DropdownTitle v-if="action.type === 'title'" v-bind="{ ...action.item, ...action.title }" />
            <DropdownSeparator v-if="action.type === 'separator'" />
            <DropdownItem
                v-if="action.type === 'item'"
                v-bind="getItemPropsWithoutOnClick(action.item)"
                @click="() => handleDropdownItemClick(action.item.onClick, action, index)"
                @select="emit('select')"
            />
        </template>
    </div>
</template>
<style scoped lang="scss">
.tooltip-generator {
    gap: 4px;
    display: flex;
    flex-direction: column;
}
</style>
